import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Grid, Button } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

class Add extends React.Component {

  state = {
    brand_name: '',
    load: false,
    message: '',
  }

  add() {
    let context = this;
    let brand_name = this.state.brand_name;
    if (brand_name == '' || brand_name == null || brand_name == undefined) {
      this.setState({
        error: 'Enter the Brand name',
      })
      return;
    }
    let data1 = { 'brand_name': brand_name };
    context.setState({
      load: true,
      message: 'Add Brand!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/branddetails/add.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.props.updateDatas();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  onChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <form noValidate autoComplete="off">
              <TextField
                id="outlined-name"  label="Brand Name"
                value={this.state.brand_name} fullWidth
                onChange={this.onChange('brand_name')}
                margin="normal" variant="outlined" />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <center><div style={{color: 'red'}}>{this.state.error}</div></center>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={ () => { this.props.handleClose(); } }>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.add.bind(this)}>Save</Button>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Add;
